import React from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import styled from 'styled-components';
import { isValidEmail } from '~/helper';
import Modal from '~/components/modal';
import { InputGroup } from '~/components/form';

const Container = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;

  .tip {
    margin-bottom: 10px;
    padding: 10px 8px;
    font-size: 90%;
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }

  img {
    max-width: 100px;
    max-height: 100px;
    align-self: center;
    display: flex;
  }
`;

const EmployeeSchema = Yup.object().shape({
  emails: Yup.mixed().test('', 'Informe emails válidos', function(value) {    
    let invalids = _.filter(String(value).split(','), (r) => !isValidEmail(r.trim()));
    return value && _.isEmpty(invalids);
  })
});

function EmployeeModal({ data, title, isOpen, loading, closeModal, handleOnSubmit }) {

  return (
    <Formik
      enableReinitialize={true}
      initialValues={data}
      validationSchema={EmployeeSchema}
      initialTouched={{ emails: true }}
      >
      {({ values, isValid, touched, errors, handleReset }) => (
        <Modal
          width="560px"
          height="250px"
          hideClose={true}
          open={isOpen}
          hide={closeModal}
          title={title}
          actions={[
            {
              label: 'Cancelar',
              action: () => { handleReset() ; closeModal() },
              disabled: loading
            },
            {
              label: 'Baixar',
              action: () => handleOnSubmit('download'),
              primary: true,
              disabled: loading
            },
            {
              label: 'Enviar por email',
              action: () => handleOnSubmit('email', values.emails),
              primary: true,
              disabled: !values.emails || !isValid || loading
            }
          ]}
          >
          <Container>
            <label className="tip">
              Informe os emails separados por vírgula para enviar as credenciais geradas
            </label>

            <InputGroup
              type="text"
              name="emails"
              label="Email(s)"
              hasError={_.get(errors, 'emails') && _.get(touched, 'emails')} />
          </Container>
        </Modal>
      )}
    </Formik>
  );
};

export default EmployeeModal;
